<template>
  <div class="group-static">
    <div class="header-tip">
      <div class="tip-content">
        <span class="tip-icon">!</span>
        <span class="tip-text">数据统计默认为当天，可通过筛选查看历史7天数据</span>
      </div>
    </div>

    <van-sticky>
      <div class="filter-area">
        <div class="filter-inputs">
          <div class="filter-item">
            <van-dropdown-menu active-color="#FF445E">
              <van-dropdown-item v-model="sortBy" :options="sortOptions" />
            </van-dropdown-menu>
          </div>
          <div class="filter-item time-filter">
            <div class="mock-dropdown" @click="showCalendar = true">
              <span class="text-flow">{{ dateText }}</span>
              <van-icon name="arrow-down" />
            </div>
          </div>
        </div>
        <div class="filter-btn">
          <van-button type="danger" round size="small" class="query-button" color="#FF445E" @click="handleQuery">查询</van-button>
        </div>
      </div>
    </van-sticky>

    <div class="list-area">
      <NoData v-if="!loading && list.length === 0" :showButton="false" title="暂无数据" height="3rem" />
      <template v-else>
        <div v-for="item in list" :key="item.id" class="list-item">
          <InfoCell :avatar="item.avatar" avatar-height=".56rem" :round="false" class="group-cell">
            <template #context>
              <div class="group-info">
                <div class="group-name text-flow">{{ item.name }}</div>
                <div class="group-stats">
                  <span class="stat-item">发言人数：<span class="stat-num">{{ item.speakers }}</span></span>
                  <span class="stat-item">发言条数：<span class="stat-num stat-number">{{ item.messages }}</span></span>
                </div>
              </div>
            </template>
          </InfoCell>
        </div>
      </template>
    </div>

    <van-calendar
      v-model:show="showCalendar"
      type="range"
      allow-same-day
      :max-range="7"
      :min-date="minDate"
      :max-date="maxDate"
      color="#FF445E"
      @confirm="onConfirm"
    />

  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import InfoCell from '../../components/InfoCell'
import { dateFormat } from '../../utils/index'
import { ApiChatRoomSpeakStatistics } from '../../api/ChatRoomStatistics'
import { Toast } from 'vant'

const store = useStore()
const robotInfo = computed(() => store.getters.robotInfo || {})

const sortBy = ref(1)
const sortOptions = [
  { text: '发言人数最多', value: 1 },
  { text: '发言条数最多', value: 2 },
  { text: '人均发言条数最多', value: 3 },
]

// 日期选择相关
const showCalendar = ref(false)
const today = new Date()
const startDate = ref(today)
const endDate = ref(today)
const dateText = ref(`${dateFormat(today, 'MM.dd')}-${dateFormat(today, 'MM.dd')}`)
const maxDate = today
// 仅允许最近 7 天的数据
const minDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000)

const formatStartTimeParam = (val) => `${dateFormat(val, 'yyyy-MM-dd')} 00:00:00`
const formatEndTimeParam = (val) => `${dateFormat(val, 'yyyy-MM-dd')} 23:59:59`

const mapItem = (item, idx) => ({
  id: item.chatroomId || item.roomId || item.chatRoomName || idx,
  name: item.chatroomName || item.chatRoomName || item.groupName || '-',
  // 为空时交给 AvatarImg 组件使用默认头像
  avatar: item.chatroomImgUrl || item.chatRoomImg || item.headImgUrl || '',
  speakers: item.speakMember ?? item.speakUserCount ?? item.speakPeople ?? item.speakUserNum ?? 0,
  messages: item.speakCount ?? item.speakNum ?? item.speakMessageCount ?? 0
})

const list = ref([])
const loading = ref(false)
let loadingToast = null

const fetchStatistics = async () => {
  if (!robotInfo.value?.robotWxId) {
    console.warn('robotWxId 缺失，无法请求数据')
    list.value = []
    loading.value = false
    return
  }
  loading.value = true
  if (loadingToast) loadingToast.clear()
  loadingToast = Toast.loading({
    message: '数据加载中...',
    forbidClick: true,
    duration: 0
  })
  try {
    const res = await ApiChatRoomSpeakStatistics({
      robotSerialNo: robotInfo.value.robotWxId,
      sortType: sortBy.value,
      startTime: formatStartTimeParam(startDate.value),
      endTime: formatEndTimeParam(endDate.value)
    })
    const listRaw = Array.isArray(res?.dataList) ? res.dataList : (Array.isArray(res) ? res : [])
    list.value = listRaw.map((item, idx) => mapItem(item, idx))
   
  } catch (e) {
    console.log(e)
    list.value = []
  } finally {
    loading.value = false
    if (loadingToast) {
      loadingToast.clear()
      loadingToast = null
    }
  }
}

const onConfirm = (values) => {
  const [start, end] = values
  startDate.value = start
  endDate.value = end
  showCalendar.value = false
  dateText.value = `${dateFormat(start, 'MM.dd')}-${dateFormat(end, 'MM.dd')}`
  fetchStatistics()
}

const handleQuery = () => {
  fetchStatistics()
}

onMounted(() => {
  fetchStatistics()
})
</script>

<style scoped lang="scss">
.group-static {
  min-height: 100vh;
  background-color: #F5F5F5;
  padding-bottom: 20px;
}

.header-tip {
  padding: 12px 12px 0;
  background-color: #fff;
  
  .tip-content {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border-radius: 90px;
    border: 1px solid #FF435F;
    font-size: 13px;
    color: #666;
    .tip-text{
      color: #FF435F;
    }
  }

  .tip-icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #FF445E;
    color: #fff;
    border-radius: 50%;
    margin-right: 3px;
    flex-shrink: 0;
    font-size: 12px;
  }
}

.filter-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: #fff;

  .filter-inputs {
    display: flex;
    gap: 10px;
    flex: 1;
  }

  .filter-item {
    flex: 1;
    
    :deep(.van-dropdown-menu__bar) {
      height: 32px;
      box-shadow: none;
      background: #F5F5F5;
      border-radius: 18px;
    }
    
    :deep(.van-dropdown-menu__title) {
      font-size: 13px;
    }
  }

  .time-filter {
    max-width: 110px;
    .mock-dropdown {
      height: 32px;
      background: #F5F5F5;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #323233;
      gap: 4px;
      
      .van-icon {
        font-size: 12px;
        color: #dcdee0;
      }
    }
  }

  .filter-btn {
    margin-left: 10px;
    .query-button {
      height: 32px;
      padding: 0 20px;
      font-size: 14px;
    }
  }
}

.list-area {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  width: 100%;
}

.group-cell {
  padding: 10px;
  width: 100%;
}

.group-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 56px;
  flex: 1;
  min-width: 0; // 关键：在 flex 容器内允许内容收缩，text-overflow 才会生效
  overflow: hidden;

  .group-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    width: 100%;
    display: block;
    max-width: 100%;
  }

  .group-stats {
    font-size: 14px;
    color: #373737;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    .stat-item {
      display: flex;
      align-items: baseline;
      line-height: 20px;
    }
    
    .stat-num {
      color: #FF445E;
      font-weight: 500;
      margin-left: 2px;
      line-height: 20px;
    }
    .stat-number {
      color: #FF7700;
    }
  }
}

.ml-2 {
  margin-left: 15px;
}

.text-flow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

:deep(.info-cell) {
  width: 100%;
  box-sizing: border-box;
}

:deep(.info-cell-l) {
  min-width: 0;
}

:deep(.the-flex) {
  min-width: 0;
}

</style>
